module.exports = __webpack_public_path__ + "img/icon0_a.c37a3642.png";